import React from "react";
import Header from "@/components/layout/Header";
import DashboardSidebar from "@/components/dashboard/DashboardSidebar";

export default function ProviderDashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-slate-50 overflow-x-hidden">
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 lg:flex lg:gap-8">
          <DashboardSidebar />
          <div className="flex-1 min-w-0">{children}</div>
        </div>
      </main>
    </div>
  );
}
